import { render, staticRenderFns } from "./RiwayatKontrol.vue?vue&type=template&id=7847e3f2&"
import script from "./RiwayatKontrol.vue?vue&type=script&lang=js&"
export * from "./RiwayatKontrol.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports